<template>
	<div :class="selfPrefix">
		<div class="cls-block">
			<section-title text="技术护航"/>
			<div class="cls-main">
				<div class="cls-item h310 mr45" v-for="(item, index) in advantageData" :key="index">
					<img class="cls-img-product" :src="item.img" alt=""/>
					<div class="item-one-row ml30 mr30">
						<div class="item-name">{{ item.name }}</div>
					</div>
					<div class="item-content line-camp-4 ml30 mr30">{{ item.content }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import sectionTitle from "../../components/sectionTitle";
export default {
  name: "ProductAdvantageRow",
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    advantageData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    sectionTitle: sectionTitle
  },
  data() {
    return {
      prefixCls: "jad-block"
    };
  },
  computed: {
    selfPrefix() {
      return `${this.prefixCls}-product-advantage-row`;
    },
    isRta() {
      return this.pageKey == 'rta'
    }
  }
};
</script>

<style lang="scss" scoped>
.jad-block-product-advantage-row {
  height: 600px;
  margin-top: 0px;
  padding: 86px 0 0px;
  background: linear-gradient(180deg, #f0f2ff 0%, #fbfcff 48.13%, white 100%);
  .cls-block {
    width: 100%;
    
    .cls-main {
      margin: 50px auto 0;
      width: 1200px;
      display: flex;
      justify-content: center;
      .h310 {
        height: 310px;
      }
      .h260 {
        height: 260px;
      }
      .mr45 {
        margin-right: 45px;
      }
      .mr27 {
        margin-right: 27px;
      }
      .cls-item {
        padding-top: 33px;
        background: #FFFFFF;
        box-shadow: 1px 5px 24px #EEEEEE;
        border-radius: 6px;
        cursor:pointer;
        &:last-child {
          margin-right: 0;
        }
        flex: 1;
        .cls-img-product {
          width: 128px;
          height: 107px;
          display: block;
          margin: auto auto 0;
        }
        .pt-30 {
          padding-top: 30px;
        }
        .mt-50 {
          margin-top: -50px;
        }
        .mr25 {
          margin-right: 25px;
        }
        .ml25 {
          margin-left: 25px;
        }
        .mr30 {
          margin-right: 30px;
        }
        .ml30 {
          margin-left: 30px;
        }
        .item-one-row {
          margin-top: 30px;
          display: flex;
          justify-content: space-between;
          .cls-img-icon {
            width: 21px;
            height: 16px;
          }
          .item-name {
            line-height: 22px;
            font-size: 18px;
            font-family: PingFangSC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
          }
        }
        .line-camp-4 {
          -webkit-line-clamp: 4;
        }
        .line-camp-5 {
          -webkit-line-clamp: 5;
        }
        .item-content {
          margin-top: 14px;
          margin-bottom: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: normal;
          color: rgba(102, 102, 102, 1);
          text-align: justify;
          line-height: 22px;
        }
      }
      .cls-item:hover {
        box-shadow: 1px 5px 24px rgba(144, 153, 209, 0.6);
      }
    }
  }
}
</style>
